import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getOrderInfo } from '@/api/order';
import OrderInfoTab from './OrderInfoTab.vue';
import OrderProductTab from './OrderProductTab.vue';
import OrderUserTab from './OrderUserTab.vue';
import OrdersTransactionTab from './OrdersTransactionTab.vue';
import OrderDispatchTab from './OrderDispatchTab.vue';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.orderId = null;
    this.orderInfoData = null;
  }
  activated() {
    this.orderId = this.$route.params.id;
    this.getOrderInfo();
  }
  async getOrderInfo() {
    try {
      this.orderInfoData = await getOrderInfo(this.orderId);
    } catch (error) {
      this.$message(error.toString());
    }
  }
};
default_1 = __decorate([Component({
  name: 'OrderInfo',
  components: {
    OrderInfoTab,
    OrderProductTab,
    OrderUserTab,
    OrdersTransactionTab,
    OrderDispatchTab
  }
})], default_1);
export default default_1;